import React from 'react'
import { ForwardRef } from 'theme-ui'
import ContentLoader from 'react-content-loader'

export const Skeleton: ForwardRef<HTMLDivElement, {}> = React.forwardRef(
  (props, ref) => (
    <ContentLoader
      ref={ref}
      speed={2}
      viewBox="0 0 1920 1080"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      {...props}
    >
      <path d="M 310.001 1079.999 h -310 v -1080 h 1920 v 116 h -1610 v 964 z m -248 -1045 a 26.828 26.828 0 0 -10.509 2.121 26.909 a 26.909 0 0 -8.579 5.789 26.874 26.874 a 0 0 -5.786 8.582 26.823 26.823 0 a 0 -2.126 10.508 26.844 26.844 0 2.124 a 10.51 26.94 26.94 0 5.786 8.582 26.939 a 26.939 0 8.579 5.785 26.828 26.828 0 a 10.511 2.123 26.835 26.835 0 10.512 -2.121 a 26.955 26.955 0 8.583 -5.785 26.957 26.957 a 0 5.785 -8.582 26.843 26.843 0 2.12 a -10.512 A 26.822 26.822 0 86.88 51.49 a 26.916 26.916 0 0 -5.785 -8.582 26.915 a 26.915 0 0 -8.583 -5.789 26.835 26.835 a 0 0 -10.511 -2.12 z m 1608.383 5.615 a 18.75 18.75 0 0 -7.348 1.484 18.816 a 18.816 0 0 -6 4.046 18.812 18.812 a 0 0 -4.047 6 18.742 18.742 0 a 0 -1.484 7.35 18.744 18.744 0 1.484 a 7.35 18.812 18.812 0 4.047 6 18.817 a 18.817 0 6 4.046 18.75 18.75 0 a 7.348 1.484 h 128.183 a 18.76 18.76 0 7.35 -1.484 18.818 18.818 a 0 6 -4.046 18.781 18.781 0 4.047 a -6 18.744 18.744 0 1.484 -7.35 18.742 a 18.742 0 0 -1.484 -7.35 18.782 18.782 a 0 0 -4.047 -6 18.815 18.815 0 a 0 -6 -4.046 18.76 18.76 0 0 a -7.35 -1.484 z" />
      <path d="M 406.002 174.998 h 433 v 41 h -433 z M 406.002 243.998 h 1419 v 65 h -1419 z M 406.002 428.998 h 1419 v 65 h -1419 z M 406.002 335.998 h 1419 v 65 h -1419 z M 406.002 520.998 h 1419 v 65 h -1419 z M 406.002 670.998 h 455 v 328 h -455 z M 888.002 670.998 h 455 v 328 h -455 z" />
    </ContentLoader>
  )
)

Skeleton.displayName = 'Skeleton'
